const header = () => {

    document.addEventListener('DOMContentLoaded', () => {

        /**
         * Scroll down
         */

        const navbar = document.querySelector('.navbar');
        if (navbar) {
            window.addEventListener('scroll', () => {
                if (window.scrollY > 60) { 
                    navbar.classList.add('scrolled');
                } else {
                    navbar.classList.remove('scrolled');
                }
            });
        }

        /**
         * Mobile Navbar toggler
         */

        const toggler = document.querySelector('.navbar__toggler');
        const wrapper = document.querySelector('.navbar__wrapper');
        if (toggler && wrapper) {
            toggler.addEventListener('click', (e) => {
                toggler.classList.toggle('active');
                wrapper.classList.toggle('active');
            });
        }

        /**
         * Dropdowns
         */

        const dropdowns = document.querySelectorAll('.dropdown');
        if (dropdowns.length > 0) {
            dropdowns.forEach(dropdown => {
                const toggle = dropdown.querySelector('.dropdown__toggle');
                const wrapper = dropdown.querySelector('.dropdown__wrapper');

                toggle.addEventListener('mouseover', (e) => {
                    e.preventDefault();
                    dropdowns.forEach(el => {
                        if (el !== dropdown) {
                            const elWrap = el.querySelector('.dropdown__wrapper');
                            elWrap.classList.remove('active');
                        }
                    })
                    wrapper.classList.toggle('active');
                })

                window.addEventListener('click', (e) => {
                    if (e.target != dropdown && e.target != toggle && e.target != wrapper) {
                        wrapper.classList.remove('active');
                    }
                });
            })
        }
    });

}

export default header;